"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MonitorOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var MonitorOutlineSVG = function MonitorOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M28,4H4A2,2,0,0,0,2,6V21a2,2,0,0,0,2,2h9v3H10a1,1,0,0,0,0,2H22a1,1,0,0,0,0-2H19V23h9a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,2V17H4V6ZM4,21V19H28v2Z"
  }));
};
exports.MonitorOutlineSVG = MonitorOutlineSVG;
MonitorOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(MonitorOutlineSVG);
exports.default = _default;